import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import $ from "jquery";
window.jQuery = $;
gsap.registerPlugin(ScrollTrigger);
$(window).on("load", function () {
  ScrollTrigger.batch(".fade-in-up", {
    batchMax: 16,
    once: true,
    onEnter: (batch) => {
      gsap.to(batch, {
        autoAlpha: 1,
        y: "0",
        stagger: 0.1,
        delay: 0.25,
        duration: 0.3,
      });
    },
  });
});
